export default "__VITE_ASSET__CMOWbQ5B__"